import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import Typography from '@material-ui/core/Typography'
import React, { useState } from 'react'
import { useNotify, useRefresh } from 'react-admin'
import { Handler } from 'shared/helpers/typeHelper'

import { DriverStatus, RoleNames } from 'helpers/constants'
import { resetUser } from '../../api/core'
import { hasPermission, Permissions } from '../../Permissions'

interface UserResetProps {
  record: any
  permissions: any
  children: (handleReset: Handler) => React.ReactNode
}

export const UserReset = ({ record, permissions, children }: UserResetProps) => {
  const [openResetDialog, setOpenResetDialog] = useState(false)
  const notify = useNotify()
  const refresh = useRefresh()
  const CAN_RESET_DRIVER_STATUSES = [
    DriverStatus.Eligible,
    DriverStatus.Deactivated,
    DriverStatus.Rejected,
    DriverStatus.Aborted,
  ]

  const handleResetUser = async () => {
    const userId = record.id
    resetUser(userId)
      .then(() => {
        notify('User reset!', { type: 'success' })
        refresh()
      })
      .catch((error: any) => {
        notify(JSON.stringify(error.response.data), { type: 'error' })
      })
  }

  const canResetUser = () => {
    const isAllowed = hasPermission(permissions || [], Permissions.ResetUser)
    const isDriver = record.roles?.includes(RoleNames.driver)
    const isDriverInAllowedState = isDriver && CAN_RESET_DRIVER_STATUSES.includes(record.driver?.status)
    return isAllowed && (!isDriver || isDriverInAllowedState)
  }

  const handleConfirmReset = async () => {
    setOpenResetDialog(false)
    await handleResetUser()
  }

  const handleCloseResetDialog = () => {
    setOpenResetDialog(false)
  }

  return canResetUser() ? (
    <>
      {children(() => {
        setOpenResetDialog(true)
      })}
      <Dialog open={openResetDialog} onClose={handleCloseResetDialog}>
        <DialogContent style={{ marginBottom: '10px' }}>
          <Typography variant="h5" style={{ marginBottom: '10px' }}>
            Reset User
          </Typography>
          <Typography>
            Are you sure you want to reset user {record.first_name} {record.last_name}? This will remove their
            association with team {record.team?.name}.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="text" onClick={handleCloseResetDialog}>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleConfirmReset} color="primary">
            Reset
          </Button>
        </DialogActions>
      </Dialog>
    </>
  ) : null
}
